// src/components/layout/Layout.jsx - UPDATED with mobile navigation state
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';
import CookieConsent from '../CookieConsent';


function Layout({ children }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <div className="flex flex-1 min-h-0">
                <Sidebar
                    mobileMenuOpen={mobileMenuOpen}
                    onCloseMobileMenu={closeMobileMenu}
                />
                <div className="flex-1 lg:ml-64 flex flex-col min-w-0 w-full">
                    <TopBar
                        onToggleMobileMenu={toggleMobileMenu}
                        mobileMenuOpen={mobileMenuOpen}
                    />

                    <main className="flex-1 px-2 sm:px-4 lg:px-6 xl:px-8 py-4 sm:py-6">
                    <div className="w-full max-w-none mx-auto">
                        {children}
                    </div>
                    </main>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default Layout;